import { PaymentMethodsContainer } from './PaymentMethodsContainer';

export default PaymentMethodsContainer;
